import Flickity from 'flickity-imagesloaded';

const sliders = document.querySelectorAll('.home_slider');

sliders.forEach(slider => {
    const flickety = new Flickity(slider, {
        cellSelector: '.slide',
        wrapAround: true,
        adaptiveHeight: false,
        pageDots: false,
        cellAlign: 'left',
        imagesLoaded: true,
        // arrowShape: 'M49.7333333 2 2 49.8 49.7333333 97.5333333 60.8666667 86.4 31.3466667 56.9333333 98.6666667 56.9333333 98.6666667 41.3333333 32.6666667 41.3333333 60.8666667 13.1333333'
    });
})

